module.exports = __webpack_public_path__ + "themify.a1ecc3b826d01251eddd.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/icons/themify-icons/fonts/themify.woff
// module id = ./src/assets/styles/icons/themify-icons/fonts/themify.woff
// module chunks = styles